(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('ProgramaEducativoController', ProgramaEducativoController);

    ProgramaEducativoController.$inject = ['ProgramaEducativo'];

    function ProgramaEducativoController(ProgramaEducativo) {

        var vm = this;

        vm.programaEducativos = [];

        loadAll();

        function loadAll() {
            ProgramaEducativo.query(function(result) {
                vm.programaEducativos = result;
                vm.searchQuery = null;
            });
        }
    }
})();
